import {Exclude, Expose} from "class-transformer";
import {AbstractApiModel} from "./abstract.api.model";
import {ViolationTypeEnum} from "../../core/enums/violation-type.enum";
import {ViolationReasonEnum} from "../../core/enums/violation-reason.enum";
import {ViolationStatusEnum} from "../../core/enums/violation-status.enum";

@Exclude()
export class ViolationApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public reason: ViolationReasonEnum;
  @Expose() public details: string;
  @Expose() public appeal: string;
  @Expose() public subject: string;
  @Expose() public note: string;
  @Expose() public type: ViolationTypeEnum;
  @Expose() public status: ViolationStatusEnum;
  @Expose() public updatedAt: Date;
  @Expose() public createdAt: Date;
}
